import React from 'react';
import { Dialog } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useWindowSize } from '../../../utils/hooks';
import { responsiveSizeTimesheet } from '../../../utils/constants';
import colors from '../../../scss/colors';

export default function NotificationModal({
  open,
  onClose,
  width,
  height,
  paddingX,
  children,
  gap,
  backgroundColor = 'white'
}) {
  const size = useWindowSize();

  return (
    <Dialog
      open={!!open}
      onClose={onClose}
      sx={{
        zIndex: 1600,
        '& .MuiDialog-paper': {
          position: 'relative',
          borderRadius: '20px',
          width: width || (size.width > responsiveSizeTimesheet ? '460px' : '336px'),
          height,
          minHeight: size.width > responsiveSizeTimesheet ? '450px' : '405px',
          boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)',
          paddingX: paddingX || (size.width > responsiveSizeTimesheet ? '118px' : '50px'),
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap,
          backgroundColor
        }
      }}
    >
      <CloseIcon
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: '15px',
          right: '15px',
          color: colors.MEDIUM_GREY,
          fontSize: '30px',
          '&:hover': {
            cursor: 'pointer'
          }
        }}
      />
      {children}
    </Dialog>
  );
}
